import momentLocalTimezone from 'src/utils/momentLocalTimezone';

const makeInitialState = values => {
  return {
    id: values.id ?? '',
    term: values.term ?? '',
    initialPayment: values.initialPayment ?? '',
    moreInfo: values.moreInfo ?? '',
    price: values.price ?? '',
    initialPaymentAmount: values.initialPaymentAmount ?? '',
    initialPaymentDate: values.initialPaymentDate
      ? momentLocalTimezone(values.initialPaymentDate)
      : momentLocalTimezone(),
    firstRentDate: values.firstRentDate
      ? momentLocalTimezone(values.firstRentDate)
      : momentLocalTimezone(),
    iva: values.iva ?? ''
  };
};

export default makeInitialState;
